import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import * as Toast from '../../lib/Toast.js';
import FileImportModal from '../FileImportModal.jsx';

const ImportEventsModal = ({ isOpen, onClose, onSuccess }) => {
    const { save, isSaving } = useBusinessPostApi(`/import/events`);
    const MAX_IMPORT_SIZE = 750;

    function doSave(data) {
        if (data.length > MAX_IMPORT_SIZE) {
            Toast.error(
                `Max import is ${MAX_IMPORT_SIZE} at one time. Please split this file up and try again.`,
            );
            return;
        }

        return save({ rows: data }).then(result => {
            Toast.success(
                `Successfully imported ${result.count} events${result.skipped > 0 ? `, skipped ${result.skipped} because they were missing an email or name to match to a client` : ''}`,
            );
            onSuccess();
        });
    }

    return (
        <FileImportModal
            isOpen={isOpen}
            onClose={onClose}
            doSave={doSave}
            title="Import Events"
            template={{
                columns: [
                    {
                        name: 'Event Type',
                        key: 'event_type',
                        description: 'Name of the type of appointment',
                        required: true,
                        suggested_mappings: ['Type'],
                    },
                    {
                        name: 'Start Date/Time',
                        key: 'start',
                        required: true,
                        suggested_mappings: ['Start'],
                    },
                    {
                        name: 'End Date/Time',
                        key: 'end',
                        required: true,
                        suggested_mappings: ['End'],
                    },
                    {
                        name: 'Booked With',
                        key: 'calendar',
                        description:
                            'Person, Resource, or Calendar that this event is booked on. Name must exactly match what is listed in Availability.',
                        required: true,
                        suggested_mappings: ['Calendar', 'Staff'],
                    },
                    {
                        name: 'First Name',
                        key: 'first_name',
                        required: false,
                        suggested_mappings: ['First'],
                    },
                    {
                        name: 'Last Name',
                        key: 'last_name',
                        required: false,
                        suggested_mappings: ['Last'],
                    },
                    {
                        name: 'Email',
                        key: 'email',
                        required: true,
                        suggested_mappings: ['Email', 'E-mail'],
                    },
                    {
                        name: 'Phone',
                        key: 'phone',
                        required: false,
                        suggested_mappings: ['Phone'],
                    },
                    {
                        name: 'Notes',
                        key: 'notes',
                        required: false,
                        suggested_mappings: ['Note'],
                    },
                ],
            }}
        />
    );
};

export default ImportEventsModal;
